exports = module.exports = require("./../../../../react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spark-fill{stroke:none;stroke-width:0;fill:#b3d4ff}.spark-outline{stroke:#4c9aff;stroke-width:1;stroke-linejoin:round;stroke-linecap:round;fill:none}.spark-bottom-line{fill:none;stroke:#8993a4;stroke-width:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/react-scripts/~/css-loader!/opt/atlassian/pipelines/agent/build/~/less-loader!./src/css/sparkline.less
// module id = 531
// module chunks = 0